import {CapsulableEntity, EntityCapsule} from "../entity/capsule.tsx";
import {iconForEntityType} from "../fa.tsx";
import {BoxProps} from "@mui/joy";

// interface ShinwaJobEntity extends Partial<CapsulableEntity> {
//     jobCode?: string;
//     intakeCode?: string;
//     displayName?: string;
// };

type ShinwaJobEntity = CapsulableEntity;

export interface ShinwaJobCapsuleProps extends Omit<BoxProps, "children"> {
    job: ShinwaJobEntity;
}

export function ShinwaJobCapsule(props: ShinwaJobCapsuleProps) {
    const {job, ...rest} = props;
    return <EntityCapsule
        entity={{displayName: job.displayName, icon: iconForEntityType("job")}}
        {...rest}/>;
}

